export default class NullableFloat {
  constructor (value) {
    const val = parseFloat(value)
    if (isNaN(val)) {
      this.value = null
    } else {
      this.value = val
    }
  }
  hasValue () {
    return !!this.value
  }
}
